module.exports = __webpack_public_path__ + "media/assets/images/maple/slider4-27103d1b21981b73c1dad9b8dd0b93f9.jpg";